const KEY = "kodpilot-theme";
const COLORS = { dark: "#07060b", light: "#f7f5fc" };

export function getTheme() {
  return document.documentElement.getAttribute("data-theme") === "light" ? "light" : "dark";
}

// Site her açılışta koyu temayla başlar; açık tema yalnızca o ziyaret için geçerlidir.
export function applyTheme(theme) {
  const next = theme === "light" ? "light" : "dark";
  document.documentElement.setAttribute("data-theme", next);
  const meta = document.head.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute("content", COLORS[next]);
  return next;
}

export function initTheme() {
  try {
    localStorage.removeItem(KEY); // eski sürümde kaydedilmiş tercihi temizle
  } catch {
    /* private mode */
  }
  applyTheme("dark");
}
